<kendo-grid
[data]="gridView$ | async"
>
<ng-template kendoGridToolbarTemplate>
  <input
    [placeholder]="'user_search_input' | i18n"
    kendoTextBox
    (input)="onFilter($event.target.value)"
    style="width: auto"
  />
</ng-template>
    <!-- mobile view -->
    <kendo-grid-column [title]="'user_roles_title' | i18n" media="(max-width: 571px)">
      <ng-template kendoGridCellTemplate let-x>
        <div class="d-flex flex-row justify-content-between ">
          <div class="d-flex flex-column flex-1" >
            <h5 style="font-size: 18px;">
              {{ x.id }} {{ x.displayName }} ({{x.email || x.login}})
            </h5>
            <div class="d-flex flex-row align-center">
                <span *ngFor="let role of x.roles;">
                  {{role.name}};
                </span>
                <ece-btn-edit (click)="onEdit(x)" [title]="'user.grid.edit.title' | i18n"></ece-btn-edit>
            </div>
          </div>
        </div>
      </ng-template>
    </kendo-grid-column>
    <!-- desktop view -->
    <kendo-grid-column field="id" [title]="'user.grid.id.title' | i18n"  media="(min-width: 571px)">
    </kendo-grid-column>
    <kendo-grid-column field="login" [title]="'user.grid.login.title' | i18n"  media="(min-width: 571px)">
    </kendo-grid-column>
    <kendo-grid-column  media="(min-width: 571px)"
      field="displayName"
      [title]="'user.grid.displayName.title' | i18n"
    >
    </kendo-grid-column>
    <kendo-grid-column  media="(min-width: 571px)"
    field="roles"
    [title]="'user.grid.roles.title' | i18n"
  >
  <ng-template kendoGridCellTemplate let-x>
    <span *ngFor="let role of x.roles;">
      {{role.name}};
    </span>
    <ece-btn-edit (click)="onEdit(x)" [title]="'user.grid.edit.title' | i18n"></ece-btn-edit>
  </ng-template>
  </kendo-grid-column>



</kendo-grid>
